interface ShiftModalProps {
  show: boolean;
  onClose: () => void;
}

export default function ShiftModal({ show, onClose }: ShiftModalProps) {
  if (!show) return null;

  return (
    <div className="fixed inset-0 bg-black/50 backdrop-blur-sm z-50 flex items-center justify-center p-4">
      <div className="bg-white rounded-2xl shadow-2xl max-w-2xl w-full max-h-[90vh] overflow-y-auto">
        <div className="p-4 sm:p-6 border-b border-gray-200 sticky top-0 bg-white z-10">
          <div className="flex items-center justify-between">
            <h2 className="text-xl sm:text-2xl font-bold text-gray-800">見守り時間設定</h2>
            <button
              onClick={onClose}
              className="w-8 h-8 sm:w-10 sm:h-10 flex items-center justify-center rounded-full hover:bg-gray-100 transition-colors cursor-pointer flex-shrink-0"
            >
              <i className="ri-close-line text-xl sm:text-2xl text-gray-600"></i>
            </button>
          </div>
        </div>
        <div className="p-4 sm:p-6">
          <p className="text-gray-600 mb-4 sm:mb-6 text-xs sm:text-sm">
            あなたが対応可能な時間帯を設定してください。この時間帯がユーザーに表示されます。
          </p>
          <form className="space-y-4 sm:space-y-6">
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-3 sm:gap-4">
              <div>
                <label className="block text-xs sm:text-sm font-medium text-gray-700 mb-2">開始時刻</label>
                <input
                  type="time"
                  defaultValue="10:00"
                  className="w-full px-3 sm:px-4 py-2 sm:py-3 border border-gray-300 rounded-xl focus:ring-2 focus:ring-teal-500 focus:border-transparent text-xs sm:text-sm"
                />
              </div>
              <div>
                <label className="block text-xs sm:text-sm font-medium text-gray-700 mb-2">終了時刻</label>
                <input
                  type="time"
                  defaultValue="17:00"
                  className="w-full px-3 sm:px-4 py-2 sm:py-3 border border-gray-300 rounded-xl focus:ring-2 focus:ring-teal-500 focus:border-transparent text-xs sm:text-sm"
                />
              </div>
            </div>

            <div>
              <label className="block text-xs sm:text-sm font-medium text-gray-700 mb-2">対応可能な曜日</label>
              <div className="grid grid-cols-7 gap-1 sm:gap-2">
                {['月', '火', '水', '木', '金', '土', '日'].map((day) => (
                  <label key={day} className="flex items-center justify-center p-2 sm:p-3 border-2 border-gray-300 rounded-lg sm:rounded-xl hover:border-teal-500 transition-colors cursor-pointer">
                    <input type="checkbox" defaultChecked={day !== '土' && day !== '日'} className="hidden peer" />
                    <span className="peer-checked:text-teal-600 peer-checked:font-bold text-xs sm:text-sm">{day}</span>
                  </label>
                ))}
              </div>
            </div>

            <div className="bg-amber-50 border border-amber-200 rounded-xl p-3 sm:p-4">
              <p className="text-xs sm:text-sm text-amber-800">
                <strong>表示例：</strong> 「パートナーの見守り時間：平日 10:00〜17:00」
              </p>
            </div>

            <div className="flex flex-col sm:flex-row space-y-2 sm:space-y-0 sm:space-x-4">
              <button
                type="button"
                onClick={onClose}
                className="w-full sm:flex-1 px-4 sm:px-6 py-2 sm:py-3 border border-gray-300 text-gray-700 rounded-xl hover:bg-gray-50 transition-colors cursor-pointer whitespace-nowrap text-xs sm:text-sm"
              >
                キャンセル
              </button>
              <button
                type="button"
                onClick={onClose}
                className="w-full sm:flex-1 px-4 sm:px-6 py-2 sm:py-3 bg-gradient-to-r from-teal-500 to-teal-600 text-white rounded-xl hover:shadow-lg transition-all cursor-pointer whitespace-nowrap text-xs sm:text-sm"
              >
                保存する
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
}
